import Plyr from 'plyr';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger);

// Vimeo Player SDK:  https://developer.vimeo.com/player/sdk
const console = window.console;

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,
        	trackGAEvents: true,

        	scrollaAutopause: false,
        	debug: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'audio_plyr_player';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$window 		= 	$(window);

		this.init( true );
    }

    init( b ){
    	this.initPlayer( b );
    	this.addEvents( b );

    	if ( b ){
			this.$el.addClass( 'ready' );    		
    	}
	}

	initPlayer( b ){
		if ( b ){
			const player = new Plyr( this.$el.find( '.audio-plyr' ), {
				debug: this.options.debug,
                iconUrl: ($( 'body' ).attr( 'data-theme-url' )?$( 'body' ).attr( 'data-theme-url' ):'https://cfarchives.wpengine.com/wp-content/themes/Chicago-Film-Archives') + '/assets/img/plyr/plyr-audio.svg',
 				controls: ['play', 'progress', 'mute', 'volume', 'current-time', 'duration' ],
 				tooltips: { controls: false, seek: false },
 				//invertTime: false
			});

			this.player = player;

			//this.hackPauseButton();

		}
		else{
			if ( this.player){
				this.player.destroy();
				this.player = null;
			}
		}
		this.initScrollAutoPause(b)
	}

	hackPauseButton(){
		let $play = this.$el.find( '.plyr__controls__item.plyr__control' );
		$play.each((i,el)=>{
			if ( $(el).attr( 'data-plyr' ) === 'play' ){
				$(el).find(  '.icon--pressed'  ).remove();
				$(el).append( this.$el.find( '.icon-sound-playing' )  );
				this.$el.find( '.icon-sound-playing' ).css({
					opacity: 1
				})
			}
		})
	}

	initScrollAutoPause( b ){
		if ( ! this.options.scrollAutopause ){
			return;
		}


		if ( b ){
			this.scrollTriggerId = this.namespace + '_' + Math.random();
			
			ScrollTrigger.create({
				id: this.scrollTriggerId
				,scrub: true
				,trigger: this.$el
				,toggleClass: 'auto-in-view'
				,scroller: $(this.main.options.$scroll_el)
				,onToggle: (e) => {
					//console.log( e );
					this.forceAutoPause( !e.isActive );
				}
				//,markers: true
			});
		}
		else{
			ScrollTrigger.getById( this.scrollTriggerId ).kill();
		}
	}

	 //---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		const player = this.player, src =  this.$el.find(  'source' ).attr( 'src' );
		if ( b ){
			player.on('ready', (event) => {
	  			//const instance = event.detail.plyr;
				//console.log( 'PLYR READY' );
				//console.log( event );
			});
			player.on('play', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Audio Play', 'Audio Play', src , document.location.href  );
		    	}
			});
			player.on('pause', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Audio Pause', 'Audio Pause', src , document.location.href  );
		    	}
			});
		}
		else{
			player.off('ready', (event) => {
	  			//const instance = event.detail.plyr;
				//console.log( 'PLYR READY' );
				//console.log( event );
			});
			player.off('play', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Audio Play', 'Audio Play', src , document.location.href  );
		    	}
			});
			player.off('pause', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Audio Pause', 'Audio Pause', src , document.location.href  );
		    	}
			});
		}
		this.debounceResize(b);
	}

    debounceResize( b ){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 77 );
			this.$window.on( 'resize', this._debResize );

			this.onResize()
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$window.off( 'resize', this._debResize );
			}        
		}
    }

    onError( error ){
    	let str = this.namespace + ' : ';
		switch (error.name) {
			case 'PasswordError':
				str += 'The video is password-protected';
			break;
			case 'PrivacyError':
				str += 'The video is private';
			break;
			default:
				str += error.message;
		}
		console.log( error );
		console.log( str );
    }

    onResize(){
		if ( this.options.autopause ){
			ScrollTrigger.refresh();
		}
    }

    //---------------------------------------- METHODS ---------------------------------------//
    play( b ){
    	if ( !this.player) return;

    	if ( b ){
    		this.player.play();
    	}
    	else{
    		this.player.stop();
    	}
	}

	pause(){
		if ( !this.player) return;
		this.player.pause();
	}

    togglePlay(){
		if ( !this.player) return;
		this.player.togglePlay();
    }

    // fired by ScrollTrigger if this.options.autopause is true
    forceAutoPause( b ){
    }

    destroy(){
    	this.addEvents( false );
    	this.initPlayer( false );
    }

}


